import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import RunSheetDriverList from './RunSheetDriverUpdateList';
import RunSheetDriverCallout from './RunSheetDriverUpdateCallout';
import RunSheetDriverPlan from './RunSheetDriverUpdatePlanChanges';
import RunSheetDriverOffice from './RunsheetDriverUpdateOffice';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface RunSheetDriverUpdate {
    tab: string;
    invoiceItemTypes: ItemTypeList[];
    invoiceItems: ItemList[];
    itemOptions: ItemOptionList[];
    gst: number;
    jobs: Job[];
    jobIndex: number;
    job: Job;
    systemCompanyId: number;
    loading: boolean;
}

interface Job {
    runsheetId: number;
    scheduleDate: string;
    scheduleDateFormatted: string;
    truck: string;
    jobId: number;
    siteAddress: string;
    updateTypeId: number;     //1=Callout, 2=Plan Changes
    estimatedTime: string;
    departureTime: string;
    siteArrivalTime: string;
    downTime: string;
    siteCompletionTime: string;
    driverNotes: string;
    chargeCalloutFee: number;
    noCalloutInvoiceNotes: string;
    calloutNotes: string;
    planChangesReason: string;
    officeNotes: string;
    items: JobItem[];
    invoiceItems: ExtraInvoiceItem[];
}

interface JobItem {
    id: number;
    typeId: number;
    type: string;
    item: string;
    itemId: number;
    hirePeriod: number;
    unitNumber: string; //if site address has a unit number
    quantityTotal: number;
    quantity: number;
    quantityScheduled: number;
    quantityType: string;
    price: number;
    fuelSurchargeAmount: number;
    overhireRate: number;
    isKwikstage: boolean;
    kwikstageItems: KwikstageScheduleItem[];
}

interface KwikstageScheduleItem {
    scheduleKwikstageId: number;
    jobQuoteItemCalculationId: number;
    starterBayId: number;
    starterBay: string;
    liftId: number;
    lift: string;
    baysTotal: number;
    baysComplete: number;
}

interface ExtraInvoiceItem {
    rowIndex: number;
    id: number;
    itemId: number;
    itemTypeId: number;
    scheduleId: number;
    jobQuoteItemId: number;
    rate: number;
    gst: number;
    amount: number;
    description: string;
    active: boolean;
}

//invoice item list - for callout invoice
interface ItemTypeList {
    id: number;
    name: string;
    chargeGst: boolean;
}

interface ItemList {
    id: number;
    jobQuoteItemId: number;
    name: string;
    chargeGst: boolean;
}

//item list
interface ItemOptionList {
    id: number;
    name: string;
    unitOfMeasure: string;
    chargeGst: boolean;
    callout: boolean;
    priceListItem: boolean;
    priceListDefaultDays: number;
    isWalkWay: boolean;
    typeId: number;
    installOnly: boolean;
}

export class RunSheetDriverUpdateData extends React.Component<RouteComponentProps<{}>, RunSheetDriverUpdate> {
    constructor(props: any) {
        super(props);

        this.state = {
            jobs: [],
            tab: "list",
            invoiceItems: [],
            invoiceItemTypes: [],
            itemOptions: [],
            gst: 0.1,
            jobIndex: 0,
            job: {
                runsheetId: 0,
                scheduleDate: "",
                scheduleDateFormatted: "",
                truck: "",
                jobId: 0,
                siteAddress: "",
                updateTypeId: 1,
                estimatedTime: "",
                departureTime: "",
                siteArrivalTime: "",
                downTime: "",
                siteCompletionTime: "",
                driverNotes: "",
                chargeCalloutFee: -1,
                noCalloutInvoiceNotes: "",
                calloutNotes: "",
                planChangesReason: "",
                officeNotes: "",
                items: [],
                invoiceItems: []
            },
            systemCompanyId: 2,
            loading: true
        };
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/CheckUserPermission?Permission=ViewRunSheetUpdates&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                this.getInvoiceTypes();
            } else {
                //redirect to 403 permission denied
                this.props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    async getInvoiceTypes() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //get item list
        axios.get('api/Job/GetItems?SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        }).then(res => {
            this.setState({ itemOptions: res.data });
        }).catch(error => {
            toast.error(error.message);
        });

        //get invoice item types
        axios.get('api/Invoicing/GetInvoiceItemTypes?SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            this.setState({ invoiceItemTypes: res.data.itemTypes, gst: res.data.gst });

            this.getRunsheetDriverJobs();
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    async getRunsheetDriverJobs() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/RunSheet/GetRunsheetDriverJobs?subId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            this.setState({ jobs: res.data.jobs, systemCompanyId: res.data.systemCompanyId, loading: false });
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    resetJob = () => {
        var job: Job = {
            runsheetId: 0,
            scheduleDate: "",
            scheduleDateFormatted: "",
            truck: "",
            jobId: 0,
            siteAddress: "",
            updateTypeId: 1,
            estimatedTime: "",
            departureTime: "",
            siteArrivalTime: "",
            downTime: "",
            siteCompletionTime: "",
            driverNotes: "",
            chargeCalloutFee: -1,
            noCalloutInvoiceNotes: "",
            calloutNotes: "",
            planChangesReason: "",
            officeNotes: "",
            items: [],
            invoiceItems: []
        };

        return job;
    }

    updateJob = (job: Job) => {
        this.setState({ job: job });
    }

    gotoList = () => {
        var job = this.resetJob();

        this.setState({ tab: "list", jobIndex: 0, job: job });
    }

    gotoCallout = (jobIndex: number) => {
        var job = this.state.jobs[jobIndex];

        //create a blank callout row
        var invoiceItems: ExtraInvoiceItem[] = [];
        var invoiceItem: ExtraInvoiceItem = {
            rowIndex: 0,
            id: job.runsheetId,
            itemId: -1,
            itemTypeId: -1,
            scheduleId: 0,
            jobQuoteItemId: 0,
            rate: 0,
            gst: 0,
            amount: 0,
            description: "",
            active: true
        };
        invoiceItems.push(invoiceItem);
        job.invoiceItems = invoiceItems;

        this.setState({ tab: "callout", jobIndex: jobIndex, job: job });
    }

    saveCallout = () => {
        this.saveCalloutItem();
    }

    async saveCalloutItem() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var job = this.state.job;
        job.invoiceItems.pop();

        var callout = {
            scheduleDate: job.scheduleDate,
            runsheetId: job.runsheetId,
            jobId: job.jobId,
            truck: job.truck,
            departureTime: job.departureTime,
            siteArrivalTime: job.siteArrivalTime,
            downTime: job.downTime,
            siteCompletionTime: job.siteCompletionTime,
            calloutNotes: job.calloutNotes,
            noCalloutInvoiceNotes: job.noCalloutInvoiceNotes,
            extraInvoiceItems: job.invoiceItems,
            subId: user.sub
        };

        //save callout invoice
        axios.post('api/RunSheet/SaveRunsheetDriverCallout', callout, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            toast.success("Callout Invoice Saved");

            var resetJob = this.resetJob();
            this.setState({ job: resetJob, tab: "list", jobIndex: 0 });

            //get updated list
            this.getRunsheetDriverJobs();
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    gotoPlanChanges = (jobIndex: number) => {
        var job = this.state.jobs[jobIndex];

        this.setState({ tab: "plan", jobIndex: jobIndex, job: job });
    }

    savePlanChanges = () => {
        var resetJob = this.resetJob();
        this.setState({ job: resetJob, tab: "list", jobIndex: 0 });

        //get updated list
        this.getRunsheetDriverJobs();
    }

    gotoOfficeUpdate = (jobIndex: number) => {
        var job = this.state.jobs[jobIndex];

        this.setState({ tab: "office", jobIndex: jobIndex, job: job });
    }

    saveOfficeUpdates = () => {
        this.saveOfficeUpdateItem();
    }

    async saveOfficeUpdateItem() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var job = this.state.job;

        var officeUpdate = {
            scheduleDate: job.scheduleDate,
            runsheetId: job.runsheetId,
            jobId: job.jobId,
            truck: job.truck,
            departureTime: job.departureTime,
            siteArrivalTime: job.siteArrivalTime,
            downTime: job.downTime,
            siteCompletionTime: job.siteCompletionTime,
            officeNotes: job.officeNotes,
            items: job.items,
            subId: user.sub
        };

        //save plan change updates - price / quantity
        axios.post('api/RunSheet/SaveRunsheetOfficeUpdate', officeUpdate, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            toast.success("Plan Changes Saved");

            var resetJob = this.resetJob();
            this.setState({ job: resetJob, tab: "list", jobIndex: 0 });

            //get updated list
            this.getRunsheetDriverJobs();
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        var contents;
        if (this.state.tab == "list") {
            contents = <RunSheetDriverList jobs={this.state.jobs} gotoCallout={this.gotoCallout} gotoPlanChanges={this.gotoPlanChanges} gotoOfficeUpdate={this.gotoOfficeUpdate} />
        }
        else if (this.state.tab == "callout") {
            contents = <RunSheetDriverCallout invoiceItems={this.state.invoiceItems} invoiceItemTypes={this.state.invoiceItemTypes} gst={this.state.gst} job={this.state.job} updateJob={this.updateJob} save={this.saveCallout} />
        }
        else if (this.state.tab == "plan") {
            contents = <RunSheetDriverPlan systemCompanyId={this.state.systemCompanyId} runsheetId={this.state.job.runsheetId} jobId={this.state.job.jobId} itemOptions={this.state.itemOptions} save={this.savePlanChanges} />
        }
        else if (this.state.tab == "office") {
            contents = <RunSheetDriverOffice job={this.state.job} updateJob={this.updateJob} save={this.saveOfficeUpdates} />
        }

        return (
            <div>
                {contents}
            </div>
        );

    }

};